
const transAjaxData = (data) => {
  let reJson = {};
  for(let key in data){
    if(Array.isArray(data[key])){
      reJson['tableInfo'+key.toUpperCase()] = data[key];
    }else{
      reJson = {...reJson,...data[key]};
    }
  }
  return reJson;
}
const transAjaxData_old = (data) => {

  let tableList_r = data.r;  //资源
  let tableList_n = data.n; //内容
  let tableList_w = data.w; //内容
  let tableList_i = data.i; //项目
  let formInfo = data.bd;
  let reJson = {
    ...formInfo,...tableList_w,...tableList_i,
    tableInfoR:tableList_r,
    tableInfoN:tableList_n
  };
  return reJson;
}

const transAjaxData2 = (data) => {

  let tableList = [];
  let formInfo = {};
  data.forEach(element => {
    let dlist={};
    if(Object.keys(element.b).length>0){
      dlist = element.b;
    }else if(Object.keys(element.n).length>0){
      dlist = element.n;
    }else if(Object.keys(element.p).length>0){
      dlist = element.p;
    }
    // dlist 遍历所有项，如果key是以 b_或d_,w_开头则 dlist 加上这个属性
    for(let key in dlist){
      if(key.startsWith('b_') || key.startsWith('d_')|| key.startsWith('w_')){
        formInfo[key] = dlist[key];
      }
    }


    tableList.push(dlist);
  });
  let reJson = {
    ...formInfo,
    tableInfo:tableList
  };


  return reJson;
}



export default transAjaxData;


